import React from 'react';
import { useTranslation } from 'react-i18next';

import { EMPLOYEES_LIST, EMPLOYEE_ATTENDANCE_LIST, EMPLOYEE_PAY_LIST } from 'src/constants/EndpointUrls';
import { Employee, Kintai, Calculator, Pulldown, ArrowBold } from 'jbc-front/components/icons';
import { redirectTo, serializeHttpGetParams } from 'src/utils/Http';

import styles from './EmployeeAndSalarySetting.scss';

const listUrl = (mostRecentNotConfirmedSalary, urlFormat) => {
  if (!mostRecentNotConfirmedSalary) {
    return urlFormat;
  }

  const { yearMonth, payrollRulesGroups } = mostRecentNotConfirmedSalary;
  return `${urlFormat}?${serializeHttpGetParams({ yearMonth, payrollRulesGroups })}`;
};
export const TodoComponent = ({ title, icon, content, onClick ,id}) => {

  return (
    <div id={id} className={styles.item} onClick={() => onClick()} role="presentation">
      <div id="icon" className={styles.icon}>
        {icon}
      </div>
      <div className={styles.info}>
        <div className={styles.title} id="title">{title}
        </div>
      </div>
      <div className={styles.arrow}>
        <Pulldown size={10} />
      </div>
      <div className={styles.hintLabel}>
        <div className={styles.content} id="content">
          {content}
        </div>
      </div>
    </div>
  )
}

const EmployeeAndSalarySetting = ({ mostRecentNotConfirmedSalary }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className={styles.todoContainer}>
      {/* 従業員情報の更新 -  Update employee information */}
      <TodoComponent
        title={t('features.Dashbord.components.EmployeeAndSalarySetting.update_employee_information')}
        content={t('features.Dashbord.components.EmployeeAndSalarySetting.update_if_employee_address_benefit_and_salary_has_changed')}
        icon={<Employee size={35} />}
        onClick={() => redirectTo(EMPLOYEES_LIST)}
        id="Employee"
      />
      <div className={styles.next}>
        <ArrowBold size={15} />
      </div>

      {/* 勤怠情報の更新 - Update attendance information*/}
      <TodoComponent
        title={t('features.Dashbord.components.EmployeeAndSalarySetting.update_attendance_information')}
        content={t('features.Dashbord.components.EmployeeAndSalarySetting.Integrate_and_check_attendance_information')}
        icon={<Kintai size={35} />}
        onClick={() => redirectTo(listUrl(mostRecentNotConfirmedSalary, EMPLOYEE_ATTENDANCE_LIST))}
        id="Attendance"
      />

      <div className={styles.next}>
        <ArrowBold size={15} />
      </div>

      {/* 給与計算 - Payroll*/}
      <TodoComponent
        title={t('features.Dashbord.components.EmployeeAndSalarySetting.payroll')}
        content={t('features.Dashbord.components.EmployeeAndSalarySetting.check_and_confirm_salary_information')}
        icon={<Calculator size={35} />}
        onClick={() => redirectTo(listUrl(mostRecentNotConfirmedSalary, EMPLOYEE_PAY_LIST))}
        id="Payroll"
      />

    </div>
  );
};
export default EmployeeAndSalarySetting;
